import * as React from 'react';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import RampSignInSignUp from './RampSignInSignUp';

// eslint-disable-next-line @estee/elc-best-practice/uses-observer
export const VulcanSignInSignUp = ({ translations = {}, config = {} }) => {
    const viewController = React.useMemo(
        () => diContainer.get(serviceNames.rampSignInSignUpViewController),
        []
    );

    return (
        <RampSignInSignUp
            config={config}
            translations={translations}
            viewController={viewController}
        />
    );
};
